// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3GP6R","header":"Messages_header__20n_s"};